import axiosHttp from "services/axiosHttp";

const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubDashBoardDetail = createAsyncThunk("fetchSubDashBoardDetail", async ({ id }) => {
	const token = localStorage.getItem("auth_token");
	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};
	const response = await axiosHttp.get(`analytics/subdashboard/details?id=${id}`, config);
	return response.data.data;
});

const SubDashboardDetailSlice = createSlice({
	name: "SubDashboardDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},
	extraReducers: (builder) => {
		builder.addCase(fetchSubDashBoardDetail.pending, (state, action) => {
			state.isLoading = true;
		});

		builder.addCase(fetchSubDashBoardDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSubDashBoardDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubDashboardDetailSlice.reducer;
